import styled from "styled-components";

import OutlinedButton from "../../../../shared/components/buttons/OutlinedButton.styled";

interface StyledLocalePickerProps {
  isVisible: boolean;
}

const StyledLocalePicker = styled.div<StyledLocalePickerProps>`
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  flex: 0;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  user-select: none;

  ${OutlinedButton} {
    border: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    padding: 12px 12px 12px 16px;
    height: 48px;
    outline: none;

    p {
      color: ${({ theme }) => theme.colors.primary1};
    }

    img {
      margin-left: 10px;
      height: 20px;
      width: 20px;
    }

    &:hover {
      p {
        color: ${({ theme }) => theme.colors.baseWhite};
      }
    }
  }
`;

export default StyledLocalePicker;
